import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import BaseComponent from '../../../baseClasses/BaseComponent';
import PhotoPermissionsUtil from '../../../helpers/permissions/PhotoPermissionsUtil';
import answerYes from '../../../assets/images/answer-yes.svg';
import answerNo from '../../../assets/images/answer-no.svg';
import answerNA from '../../../assets/images/answer-na.svg';
import answerYesSelected from '../../../assets/images/answer-yes-selected.svg';
import answerNoSelected from '../../../assets/images/answer-no-selected.svg';
import answerNASelected from '../../../assets/images/answer-na-selected.svg';
import TaskCompletionStepPhotoGrid from '../PhotoUpload/TaskCompletionStepPhotoGrid';
import StepApproval from '../StepApproval';
import TaskCompletionStepComments from '../TaskCompletionStepComments';
import CommentPopup from '../CommentPopup';
import FileUploadPreview from '../PhotoUpload/FileUploadPreview/';
import dataModel from '../../../models/DataModel';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import MiscConstants from '../../../constants/MiscConstants';
import PhotoUtil from '../../../helpers/PhotoUtil/PhotoUtil';
import PhotoUtilPlugin from '../../../helpers/PhotoUtilPlugin/PhotoUtilPlugin';
import WaitSpinner from '../../../components/WaitSpinner';
import CompletionStepUtil from '../../../helpers/CompletionStepUtil/CompletionStepUtil';
import CompletionStepPermissionsUtil from '../../../helpers/permissions/CompletionStepPermissionsUtil';
import Animate from '../../../components/Animate';
import './Inspection.scss';
import Textarea from '../../Textarea';
//import CompaniesCollection from "../../../dao/collections/CompaniesCollection"

/**
 * This component is used in the tasks container for first-time photo upload to a task's completion step
 */
// TODO: collapse <Inspection> web/mobile components
export class Inspection extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      stepState: '',
      userCanModify: false,
      completionStep: this.props.completionStep,
      loadingImage: false,
      previewFile: null,
      send: false,
      showKeyboard: true,
    }; 
    this.toggleLoading = this.toggleLoading.bind(this);
    this.handleUploadConfirm = this.handleUploadConfirm.bind(this);
    this.handleUploadCancel = this.handleUploadCancel.bind(this);
    this.handleOnButtonClick = this.handleOnButtonClick.bind(this);
    
    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.completionStep != this.props.completionStep ||
      prevProps.completionStep.completed_at != this.props.completionStep.completed_at ||
      prevProps.isFieldUser != this.props.isFieldUser
    ) {
      this.setState({ completionStep: this.props.completionStep });
    }
  }

  /* END */
  toggleLoading() {
    this.setState({ loadingImage: !this.state.loadingImage });
  }

  handleNoPhotoRequiredButton() {
    this.setState({ noPhotoRequiredComment: true });
  }

  handleKeyDown(e) {
    if (e.keyCode == 27) {
      this.setState({ noPhotoRequiredComment: false, rejectionComment: false });
    }
    //commented to prevent the comment from being sent when jumping to another line
    // else if (e.keyCode == 13 || e.keyCode == 40) {
    //   e.preventDefault()
    //   this.handleCommentSent("reject", this.state.commentText)
    // }
    else if (e.keyCode == 13 || e.keyCode == 40) {
      this.setState({ rejectionComment: true });
      this.state.showKeyboard=false;
      this.setFocus(e.target,e);

    }
  }

  handleCancelComment() {
    this.setState({
      noPhotoRequiredComment: false,
      rejectionComment: false,
      displayUploadButtons: false,
    });
    this.checkForNA();
  }

  handleOnButtonClick(){
    this.state.send=true;
    if(this.state.commentText){
      this.handleCommentSent('reject', this.state.commentText);
    }
  }

  async handleCommentSent(type, commentText) {
    this.setState({ noPhotoRequiredComment: false, rejectionComment: false });
    const { task } = this.props;
    const { completionStep } = this.state;
  
    if(this.state.send){
      const rejectedCompletionStep = await CompletionStepUtil.handleRejected(this.props.currentUser, task, completionStep, type, commentText, this.analyticsLogger);

      if (this.props.handleChildCompletionStepUpdate) {
        this.props.handleChildCompletionStepUpdate(rejectedCompletionStep);
      }
  
      this.setState({ commentText: '' });
      if (this.commentInput) {
        this.commentInput.blur();
      }
  
      if (rejectedCompletionStep) {
        if (this.props.mobileBridge.isMobile) {
          this.props.history.goBack();
        }
        else {
          this.setState({ completionStep: rejectedCompletionStep });
        }
      }
      this.setState({ send: false });
    }
   
  }

  handleCommentChange(e) {
    if(e.target.value.trim()!=''){
      this.setState({ commentText: e.target.value });
    }
    else{
      this.setState({ commentText: '' });
    }
  }

  handleStepApprove() {
    const { userStepPermissions } = this.props;
    const { completionStep } = this.state;
    if (userStepPermissions.has('is_approver')) {
      this.handleApproved(completionStep);
    }
    else if (userStepPermissions.has('is_reviewer')) {
      this.handleReviewed(completionStep);
    }
  }

  handleStepReject() {
    const { userStepPermissions, task } = this.props;
    if (userStepPermissions.has('accept/reject')) {
      if ((task.has_reviewer && this.state.completionStep.reviewed_at) || !task.has_reviewer){
        this.handleRejectApproval(this.state.completionStep);
      }
      else{
        this.handleRejectReview(this.state.completionStep);
      }
    }
  }

  handleReviewed(completionStep) {
    completionStep.reviewed_at = new Date().toJSON();
    dataModel.completionCriteriaDAO.reviewCompletionCriterion(completionStep).then(response => {
      const foundCS = dataModel.completionCriteriaDAO.findItem(this.state.completionStep.id);
      if (foundCS) {
        if (this.props.handleChildCompletionStepUpdate) {
          this.props.handleChildCompletionStepUpdate(foundCS);
        }
      }
      this.analyticsLogger.logReviewEvent();
      if (this.props.mobileBridge.isMobile) {
        this.props.history.goBack();
      }
    });
  }

  handleRejectReview(completionStep) {
    this.setState({ rejectionComment: true });
  }

  async handleApproved(completionStep) {
    if (completionStep) {
      completionStep.task_id = this.props.task.id;
      completionStep.approved_at = new Date().toJSON();
      this.analyticsLogger.logApprovalEvent();
      await dataModel.completionCriteriaDAO.approveCompletionCriterion(completionStep);

      const foundCS = dataModel.completionCriteriaDAO.findItem(this.state.completionStep.id);
      if (foundCS) {
        if (this.props.handleChildCompletionStepUpdate) {
          this.props.handleChildCompletionStepUpdate(foundCS);
        }
      }
      if (this.state.uploadComment) {
        const comment = {
          caption: 'Completion Step Approved',
          body: this.state.uploadComment,
          commentable_type: 'CompletionCriterion',
          commentable_id: completionStep.id,
          user_id: this.props.currentUser.id,
        };
        await dataModel.commentsDAO.createComment(comment, false, null, { recordDescriptor: { comments: {} } });
        this.setState({ uploadComment: '' });
      }
      if (this.props.mobileBridge.isMobile) {
        this.props.history.goBack();
      }
    }
  }

  handleRejectApproval(completionStep) {
    this.setState({ rejectionComment: true });
  }

  setFocus(element,e) {
    if (element && e==null && this.state.showKeyboard) {
      this.commentInput = element;
      this.commentInput.focus(); 
    }  
    else if(e!=null && element && !this.state.showKeyboard){
      this.commentInput = element;
      this.commentInput.blur();   
    }
  }

  handleChangeAnswer = () => {
    const stepName = this.state.completionStep.name
      .split(' ')
      .map(
        word => word.substr(0, 1).toUpperCase() + word.substr(1).toLowerCase()
      )
      .join(' ');

    const message = (
      <div>
        <p>Are you sure you want to uncheck the completion step {stepName}?</p>
      </div>
    );

    this.props.dataModel.showGlobalModal('SYSTEM_POPUP', {
      height: 184,
      width: 320,
      message: message,
      cancelButtonText: 'Cancel',
      okButtonText: 'Yes',
      handleOwnerOk: () => {
        this.handleCompleteStep();
      },
      handleOwnerCancel: () => {
        this.cancelChange();
      },
    });
  };

  cancelChange = () => {
    this.props.dataModel.systemPopup = null;
    this.setState({ checked: true });
  };

  handleCompleteStep(response) {
    if (this.props.permissions.canCompleteTask && this.props.userStepPermissions && (this.props.userStepPermissions.has('step_complete') || this.props.userStepPermissions.has('override'))) {
      const { completionStep } = this.state;
      let editCompletionStep = Object.assign({}, completionStep);
      editCompletionStep.response = response;
      this.setState({ completionStep: editCompletionStep });
      dataModel.completionCriteriaDAO.completeCompletionCriterion(editCompletionStep, response).then(cs => {
        const foundCS = dataModel.completionCriteriaDAO.findItem(this.state.completionStep.id);
        if (foundCS) {
          if (this.props.handleChildCompletionStepUpdate) {
            this.props.handleChildCompletionStepUpdate(foundCS);
          }
        }
      });
    }
  }

  handleAnswerSelected(e, response) {
    const { completionStep } = this.state;
    if (completionStep.response) {
      this.handleChangeAnswer();
    }
    else {
      this.handleCompleteStep(response);
    }
  }
  
  async handleMultipleFileSelection(e) {
    e.preventDefault();

    const { completionStep } = this.state;
    const { task } = this.props;

    const files = e.target.files;

    if (!files.length) {
      return;
    }
    else {
      this.toggleLoading();
      const updatedCS = await PhotoUtil.selectMultipleFiles(files, true, completionStep, task);
      if (updatedCS) {
        this.setState({ completionStep: updatedCS });
      }
      this.toggleLoading();
    }
  }

  handleAddButton() {
    this.setState({ displayUploadButtons: true });
  }

  handleMobileImage(e) {
    e.preventDefault();
    const uploadMethod = e.target.name;

    if (navigator && navigator.camera) {
      this.handleCancelButton();
      this.setState({ uploadMethod }, () => {
        PhotoUtilPlugin.captureMobileImage(uploadMethod, false, () => {
          this.toggleLoading();
        })
        .then((fileinfo) => {
          if (uploadMethod == 'library') {
            this.setState({ previewFile: fileinfo });
          } else {
            this.finishUpload(fileinfo);
          }
        })
        .catch((error) => {
          if (this.state.loadingImage) {
            this.toggleLoading();
          }
        });
      });
    }
  }

  finishUpload(fileinfo) {
    const { completionStep } = this.state;
    const { task } = this.props;
    // const { file, fileExtension, resizedImage, exifData } = fileinfo[0]
    const { file, fileExtension, resizedImage, exifData } = fileinfo;
    PhotoUtilPlugin.handleSaveFile(file, fileExtension, resizedImage, exifData, completionStep, task)
    .then((updatedStep) => {
      this.toggleLoading();
      this.setState({ previewFile: null, completionStep: updatedStep,loadingImage: false, uploadMethod: null });
    })
    .catch((error) => {
      if (this.state.loadingImage) {
        this.toggleLoading();
      }
    });
  }

  handleUploadConfirm() {
    this.finishUpload(this.state.previewFile);
  }

  handleUploadCancel() {
    this.toggleLoading();
    this.setState({ previewFile: null, uploadMethod: null,loadingImage: false });
  }

  handleCloseUpLoadButtons() {
    this.setState({ displayUploadButtons: false, hideUploadButtons: false });
  }

  handleCancelButton() {
    this.setState({
      hideUploadButtons: true,
    });
  }

  render() {
    const {
      editing,
      task,
      userStepPermissions,
      mobileBridge,
    } = this.props;

    let { completionStep, loadingImage } = this.state;
    if (!completionStep) {
      completionStep = this.props.completionStep;
    }
    let buttons = [];

    let canAnswerQuestion = this.props.permissions.canCompleteTask && this.props.userStepPermissions && (this.props.userStepPermissions.has('step_complete') || this.props.userStepPermissions.has('override'));

    let reviewApproveButtons = null;

    if (!editing && !this.state.rejectionComment && userStepPermissions.has &&
      userStepPermissions.has('accept/reject')) {
      reviewApproveButtons = (
        <div className={'photo-approve-reject-buttons'}>
          <StepApproval key={(task.has_reviewer && (userStepPermissions.has('is_reviewer') || this.props.currentUser.super_admin) &&
            !completionStep.reviewed_at ? '_review' : '_approve') + completionStep.id} userStepPermissions={userStepPermissions}
            handleStepReject={this.handleStepReject}
            handleStepApprove={this.handleStepApprove}
          />
        </div>
      );
    }

    let typeImage = null;
    if (completionStep.attachments && completionStep.attachments.length) {
      typeImage = (
        <TaskCompletionStepPhotoGrid
          completionStep={completionStep}
          task={task}
          attachments={completionStep.attachments}
          maxPhotos={1}
          withAcceptReject={reviewApproveButtons ? true : false}
          userStepPermissions={this.props.userStepPermissions}
          allowSwapButton={canAnswerQuestion}
          completionStepStatus={this.props.completionStepStatus}
          isInspection={true}
        />
      );
    }
    let buttonList;
    if (!editing) {
      if (mobileBridge.isMobile) {
        buttons.push(
          <div
            className="button comments-button"
            onClick={this.props.handleCommentsButton}
            key="comment-button"
          >
            {completionStep.comments && completionStep.comments.length > 0 ? (
              <div className="indicator-dot" />
            ) : null}
          </div>
        );
      }
      if (
        PhotoPermissionsUtil.canUserEditPhoto(userStepPermissions, completionStep, task) &&
            (!completionStep.attachments || 
            completionStep.attachments.length < MiscConstants.MAX_NUMBER_OF_PHOTOS)
        )
      {
        if (mobileBridge.isMobile) {
          buttons.push(<div className="button add-button" onClick={this.handleAddButton} key="add-button" />);
        } else {
          buttons.push(
            <label htmlFor="imageUpload" className="button add-button" key="add-button">
              <input id="imageUpload" type="file" onChange={this.handleMultipleFileSelection} accept="image/*" multiple />
            </label>
          );
        }
      }

      buttonList = (
        <div
          className={`photo-button-list ${
            !mobileBridge.isMobile && completionStep.attachments && completionStep.attachments.length > 1 ? 'grid-expand ' : ''
            }
          ${
            completionStep.attachments && completionStep.attachments.length == 1 ? 'single-photo' : ''
            }
          ${
            userStepPermissions && userStepPermissions.has('accept/reject') ? 'review-approve' : ''
            }`}
        >
          {buttons}
        </div>
      );
    }

    let displayComponent = typeImage;

    let commentDisplay = null;
    let background = null;
    
    let sendButton = (
      <div className="send-button disabled">
        <div className="send-text disabled">SEND</div>
      </div>
    );
    if (this.state.commentText && this.state.commentText!='') {
      sendButton = (
        <div className="send-button" onClick={this.handleOnButtonClick}>
          <div className="send-text">SEND</div>
        </div>
      );
    }
    if (!editing) {
      if (this.state.rejectionComment) {
        buttonList = null;
        if (mobileBridge.isMobile) {
        
          background = <div className="photo-background-disable" onClick={this.handleCancelComment} onTouchStart={this.handleCancelComment} />;
          commentDisplay = (
            <div className="photo-comment-input">
              <Textarea
                ref={element => {
                  this.setFocus(element,null);
                }}
                rows={3}
                className="text-input"
                placeholder="You must leave a comment to reject a Completion Step."
                onChange={this.handleCommentChange}
                value={this.state.commentText}
                onKeyDown={this.handleKeyDown}
                dataId={completionStep.id}
              />
             {sendButton}
            </div>
          );
        } else {
          const element = document.getElementById(
            'task-completion-step-comments-' + completionStep.id
          );
          const rect = element.getBoundingClientRect();
          commentDisplay = (
            <CommentPopup
              task={task}
              completionStep={completionStep}
              height={element.clientHeight}
              width={element.clientWidth}
              left={rect.left}
              top={rect.top - 20}
              type={'REJECTED'}
              commentSent={commentText =>
                this.handleCommentSent('reject', commentText)
              }
              placeholder={
                'You must leave a comment to reject a Completion Step.'
              }
              cancelComment={this.handleCancelComment}
            />
          );
        }
      }
    }

    let uploadButtons = null;
    let animate = null;

    if (this.state.displayUploadButtons && !editing) {
      buttonList = null;
      background = <div className="photo-background-disable" onClick={this.handleCancelComment} />;

      animate = (
        <Animate
          component_id="upload-buttons"
          key="upload-buttons"
          property={{ bottom: { startVal: -213, endVal: 20 } }}
          duration={250}
        />
      );
      uploadButtons = (
        <div className="upload-options" id="upload-buttons">
          <div className="outerbox">
            <button name="library" ref="library" className="upload-button top-button" onClick={this.handleMobileImage}>Upload File</button>
            <button name="camera" onClick={this.handleMobileImage} className="upload-button">Use Camera</button>
          </div>
          <div className="cancel-button" onClick={this.handleCancelButton}>
            Cancel
          </div>
        </div>
      );
    }
    if (this.state.hideUploadButtons) {
      animate = (
        <Animate
          component_id="upload-buttons"
          key="upload-buttons_hide"
          property={{ bottom: { startVal: 20, endVal: -213 } }}
          duration={250}
          completionCallback={this.handleCloseUpLoadButtons}
        />
      );
    }

    if (this.state.photoSelected) {
      buttonList = null;
    }

    let comments = null;
    if (!mobileBridge.isMobile && !editing) {
      comments = (
        <TaskCompletionStepComments
          id={'task-completion-step-comments-' + completionStep.id}
          task={task}
          completionStep={completionStep}
        />
      );
    }

    let answerButtons = null;
    if (canAnswerQuestion && !CompletionStepPermissionsUtil.canCompleteStep(task, completionStep)) {
      canAnswerQuestion = false;
    }
    switch (completionStep.response) {
    case 'YES':
      answerButtons = < div className="answer-buttons" >
          <img className="button unselected" src={answerNA} alt="na" />
          <img className={'button selected' + (!canAnswerQuestion ? ' not-editable' : '')} src={answerYesSelected} alt="yes" onClick={canAnswerQuestion ? e => this.handleAnswerSelected(e, 'YES') : null}  />
          <img className="button unselected" src={answerNo} alt="no" />
        </div>;
      break;
    case 'NO':
      answerButtons = <div className="answer-buttons">
          <img className="button unselected" src={answerYes} alt="yes" />
          <img className={'button selected' + (!canAnswerQuestion ? ' not-editable' : '')} src={answerNoSelected} alt="no" onClick={canAnswerQuestion ? e => this.handleAnswerSelected(e, 'NO') : null}  />
          <img className="button unselected" src={answerNA} alt="na" />
        </div>;
      break;
    case 'N/A':
      answerButtons = <div className="answer-buttons">
          <img className="button unselected" src={answerNo} alt="no" />
          <img className={'button selected' + (!canAnswerQuestion ? ' not-editable' : '')} src={answerNASelected} alt="na" onClick={canAnswerQuestion ? e => this.handleAnswerSelected(e, 'N/A') : null}/>
          <img className="button unselected" src={answerYes} alt="yes" />
        </div>;
      break;
    default:
      answerButtons = <div className="answer-buttons">
          <img className={'button' + (!canAnswerQuestion ? ' not-editable' : '')} src={answerNA} onClick={canAnswerQuestion ? e => this.handleAnswerSelected(e, 'N/A') : null} alt="na" />
          <img className={'button' + (!canAnswerQuestion ? ' not-editable' : '')} src={answerYes} onClick={canAnswerQuestion ? e => this.handleAnswerSelected(e, 'YES') : null} alt="yes" />
          <img className={'button' + (!canAnswerQuestion ? ' not-editable' : '')} src={answerNo} onClick={canAnswerQuestion ? e => this.handleAnswerSelected(e, 'NO') : null} alt="na" />
        </div>;
    }

    return (
      <div
        className="inspection-step"
        id={'inspection-step-' + completionStep.id}
      >
        { loadingImage && <div className='loading'><WaitSpinner /></div> }
        {animate}
        {background}
        <div className={'display-and-buttons'}>
          {!mobileBridge.isMobile &&
            completionStep.instructions && (
              <div className="photo-instructions">
                <div className="instruction-label">Question</div>
                <div className="instruction-text">
                  {completionStep.instructions}
                </div>
              </div>
            )}
          {answerButtons}
          {displayComponent}
          {buttonList}
        </div>
        {this.state.previewFile &&
          <FileUploadPreview
            fileToPreview={this.state.previewFile}
            handleUploadConfirm={this.handleUploadConfirm}
            handleUploadCancel={this.handleUploadCancel}
          />
        }
        {commentDisplay}
        {uploadButtons}
        {reviewApproveButtons}
        {comments}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    inProgress: state.main.inProgress,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
    mobileBridge: dataModel.mobileBridge,
  };
};

// For handling state change from a dispatch
export default connect(mapStateToProps, null)(withRouter(Inspection));



// WEBPACK FOOTER //
// ./src/components/TaskCompletionStepsMobile/Inspection/index.js